export default {
  CASES_TABLE: {
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'Nastala chyba pri načítaní prípadov!',
      ERROR_WHILE_LOADING_PARTNERS: 'Nastala chyba pri načítaní partnerov!',
      ERROR_WHILE_LOADING_STATES: 'Nastala chyba pri načítaní stavov!',
    },
    FILTERS: {
      APPLY: 'Použiť',
      STAGE_LABEL: 'Hlavný stav',
      CASE_ID: {
        LABEL: 'ID prípadu',
        PLACEHOLDER: 'Začnite písať...'
      },
      DEBTOR_NAME: {
        LABEL: 'Dlžník',
        PLACEHOLDER: 'Začnite písať...'
      },
      CLIENT: {
        LABEL: 'Veriteľ',
        PLACEHOLDER: 'Začnite písať...',
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Začnite písať...',
      },
      PRODUCT: {
        LABEL: 'Produkt',
        PLACEHOLDER: 'Vyberte produkt...',
        NOTICE: 'Platobná výzva',
        DEMAND_LETTER: 'Advokátsky list',
        HARD_1: 'Platobný príkaz',
        HARD_2: 'Platobný príkaz - exekúcia',
      },
      STAGE: {
        DRAFT: 'Návrh',
        ONGOING: 'Prebieha',
        CLOSED: 'Uzavreté',
      },
      STATE: {
        LABEL: 'Stav',
        PLACEHOLDER: 'Začnite písať...',
      },
      STARTED_AT: {
        LABEL: 'Dátum začiatku',
        MIN_LABEL: 'Dátum začiatku (od)',
        MAX_LABEL: 'Dátum začiatku (do)',
      },
    },
    TABLE_INFO: {
      CLOSED: 'Uzavreté prípady',
      CLOSED_INFO:
        'Ide o prípady, ktoré boli buď úspešne uhradené, alebo uzavreté z iných dôvodov.',
      DRAFT: 'Koncepty',
      DRAFT_INFO:
        'Ide o prípady, ktoré ste prerušili. Ak ste sem prišli kliknutím na odkaz "Právnik a právne riešenia" z účtu Invoice.com na faktúre Számlázz.hu, každé takéto kliknutie vytvorilo koncept.',
      ONGOING: 'Prebiehajúce prípady',
      ONGOING_INFO:
        'Ide o prípady, ktoré boli úspešne spustené a momentálne prebiehajú. Ak budete mať s ktorýmkoľvek z nich úlohu na vybavenie, pošleme vám o tom e‑mailovú notifikáciu.',
    },
    HEADERS: {
      CASE_ID: 'ID prípadu',
      REMAINING_CLAIMS: 'Zostávajúce nároky',
      ORIGINAL_CLAIMS: 'Pôvodné nároky',
      PARTIES: 'Strany',
      STATE: 'Stav',
      STARTED_AT: 'Spustené',
      LAST_EVENT: 'Posledná udalosť',
      DEADLINE: 'Lehota',
    },
    MORE_CURRENCIES: '+{{count}} ďalších',
    CASE_ACTIONS: {
      DELETE: 'Zmazať prípad',
      EDIT: 'Upraviť prípad',
      NO_ACTIONS: 'Žiadne dostupné akcie',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Detaily',
      EVENTS_LABEL: 'Udalosti',
    },
    NO_CASES: {
      TITLE: 'Nenašiel sa žiadny prípad so zadanými kritériami',
    },
  },
};
